import {
  ArrowDownOutlined,
  ArrowRightOutlined,
  InboxOutlined,
} from '@ant-design/icons';
import { Button, Tag, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import ModalComponent from '../../../../../../components/ModalComponent';
import { getToyTypeSlot } from '../../../../ultraPlanUtils';
import RoadmapToyPicker from './RoadmapToyPicker';
import ToyThumbnail from './ToyThumbnail';

const { Text } = Typography;

const SummaryToy = ({ toy, isNew, emptyText }) => {
  if (!toy) {
    return (
      <span className="slot-summary-toy is-placeholder">
        <span className="slot-summary-placeholder-icon">
          {isNew ? <ArrowDownOutlined /> : <InboxOutlined />}
        </span>
        <Text type="secondary" ellipsis>
          {emptyText}
        </Text>
      </span>
    );
  }
  const typeSlot = getToyTypeSlot(toy);
  return (
    <span className={`slot-summary-toy ${isNew ? 'is-new' : ''}`}>
      <ToyThumbnail toy={toy} size={32} preview={false} />
      <Text strong={isNew} ellipsis={{ tooltip: toy?.name }}>
        {toy?.name || '-'}
      </Text>
      {typeSlot && <Tag color={typeSlot?.color}>{typeSlot?.label}</Tag>}
    </span>
  );
};

const SelectionSummary = ({ currentToy, selectedToy }) => (
  <div className="slot-summary">
    <SummaryToy toy={currentToy} emptyText="Empty slot" />
    <ArrowRightOutlined className="slot-summary-arrow" />
    <SummaryToy
      toy={selectedToy}
      emptyText="Pick a toy from the list below"
      isNew
    />
  </div>
);

const RoadmapSlotModal = ({
  slotTarget,
  userId,
  childName,
  bigToyBlockedReason,
  loading,
  onCancel,
  onSave,
}) => {
  const { weekNumber, slotConfig, slot } = slotTarget || {};
  const [selectedToy, setSelectedToy] = useState(null);

  useEffect(() => setSelectedToy(null), [slotTarget]);

  const hasCurrentToy = !!slot?.toy;
  const isUnchanged = !selectedToy?.id || selectedToy?.id === slot?.toyId;

  const footer = (
    <div className="ultra-plan-modal-footer">
      <div className="ultra-plan-modal-footer-actions">
        <Button onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        <Button
          type="primary"
          disabled={isUnchanged}
          loading={loading}
          onClick={() => onSave(selectedToy?.id)}
        >
          {hasCurrentToy ? 'Save Change' : 'Assign Toy'}
        </Button>
      </div>
    </div>
  );

  return (
    <ModalComponent
      open={!!slotTarget}
      width={640}
      wrapClassName="ultra-plan-modal"
      title={
        <div className="ultra-plan-modal-header">
          <span className="ultra-plan-modal-title">
            {hasCurrentToy ? `Change ${slotConfig?.label || ''}` : 'Assign Toy'}
            <Tag className="swap-week-pill">{`Week ${weekNumber || ''}`}</Tag>
          </span>
          <Text type="secondary" className="ultra-plan-modal-subtitle">
            {`In-stock toys from the library that suit ${
              childName ? `${childName}'s` : "the child's"
            } age, youngest age first.`}
          </Text>
        </div>
      }
      footer={footer}
      onCancel={loading ? undefined : onCancel}
      closable={!loading}
      destroyOnClose
    >
      {slotTarget && (
        <>
          <SelectionSummary
            currentToy={slot?.toy}
            selectedToy={isUnchanged ? null : selectedToy}
          />
          <RoadmapToyPicker
            userId={userId}
            weekNumber={weekNumber}
            value={selectedToy?.id}
            excludeToyId={slot?.toyId}
            bigToyBlockedReason={bigToyBlockedReason}
            onChange={(toyId, toy) => setSelectedToy(toyId ? toy : null)}
          />
        </>
      )}
    </ModalComponent>
  );
};

export default RoadmapSlotModal;
